import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker, TimePicker } from '@mui/lab';
import { DateTime } from 'luxon';
import { FormikErrors, FormikTouched } from 'formik';
import ListReasonNotAvailable from 'practice/components/shared/list-reason-not-available';
export interface PracticeNotAvailableVM {
  date?: DateTime | null;
  reason?: string;
  time?: DateTime | null;
  reasonNotAvailable?: string;
}

interface FormProps {
  disabled?: boolean;
  onChange: (
    key: keyof PracticeNotAvailableVM,
    value: PracticeNotAvailableVM[keyof PracticeNotAvailableVM]
  ) => void;
  values?: PracticeNotAvailableVM;
  errors?: FormikErrors<PracticeNotAvailableVM>;
  touched?: FormikTouched<PracticeNotAvailableVM>;
}

const FormComponent = ({
  disabled,
  onChange,
  values,
  errors,
  touched,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <DatePicker
          label="Data chiusura *"
          aria-label="Data chiusura"
          value={values?.date || null}
          onChange={(date) => {
            onChange('date', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="date"
              fullWidth
              error={touched?.date && Boolean(errors?.date)}
              helperText={errors?.date}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora chiusura *"
          aria-label="Ora chiusura"
          value={values?.time || null}
          onChange={(date) => {
            onChange('time', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="time"
              fullWidth
              error={touched?.time && Boolean(errors?.time)}
              helperText={errors?.time}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Nota irricevibile *"
          aria-label="Nota irricevibile"
          id="reason"
          fullWidth
          inputProps={{
            maxLength: '240',
          }}
          value={values?.reason || ''}
          onChange={(event) => onChange('reason', event.target.value)}
          disabled={disabled}
          error={touched?.reason && Boolean(errors?.reason)}
          helperText={errors?.reason}
        />
      </Grid>
      <Grid item xs={12}>
        <ListReasonNotAvailable
          value={values?.reasonNotAvailable || ''}
          onChange={(event) => onChange('reasonNotAvailable', event.target.value)}
          error={touched?.reasonNotAvailable && Boolean(errors?.reasonNotAvailable)}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Practice Edit - practice not available';

const Form = memo(FormComponent);

export default Form;
